function readFiniteNumber(value) {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

export function normalizeSpirometryMetrics({ fev1, pef }) {
  const zeroedMetrics = fev1 === 0 && pef === 0;

  if (!zeroedMetrics) return { fev1, pef, zeroedMetrics: false };

  return {
    fev1: null,
    pef: null,
    zeroedMetrics: true,
  };
}

export function pickSpirometryResult(docData) {
  const r = docData?.results || docData?.spiro?.results || null;

  const fev1Raw = r?.FEV1 ?? r?.fev1 ?? null;
  const pefRaw = r?.PEF ?? r?.pef ?? null;

  const signalQualityRaw = r?.Signal_Quality ?? r?.signal_quality ?? null;
  const signalQuality =
    typeof signalQualityRaw === "string"
      ? signalQualityRaw.trim().toLowerCase()
      : null;

  return {
    ...normalizeSpirometryMetrics({
      fev1: readFiniteNumber(fev1Raw),
      pef: readFiniteNumber(pefRaw),
    }),
    signalQuality,
  };
}

export function isSpirometryFailure({ signalQuality, zeroedMetrics }) {
  return signalQuality === "fail" || zeroedMetrics === true;
}
